import {
    Agent,
    EmailAllResultBranches,
    EmailAllResultEcommerce
} from './graphql.generated';

export function pageNumberToURL(initialLocation: string, pageNumber: number) {
    const url = new URL(initialLocation, 'https://zoopla.co.uk');
    url.searchParams.set('pn', `${pageNumber}`);
    return url.pathname + url.search;
}

export function getResultsString(currentPage: number, totalResults: number) {
    const MAX_RESULTS_PER_PAGE = 25;
    if (totalResults <= MAX_RESULTS_PER_PAGE) {
        return `${totalResults} result${totalResults !== 1 ? 's' : ''}`;
    }

    return `${MAX_RESULTS_PER_PAGE * (currentPage - 1) + 1} - ${Math.min(
        MAX_RESULTS_PER_PAGE * currentPage,
        totalResults
    )} of ${totalResults} results`;
}

export const createEmailAgentsPath = (path: string) => {
    const FIND_AGENTS = '/find-agents';
    const ESTATE_AGENTS = '/estate-agents';
    const LETTING_AGENTS = '/letting-agents';

    if (path.includes(ESTATE_AGENTS)) {
        return '/for-sale' + path.split(ESTATE_AGENTS).pop();
    }

    if (path.includes(LETTING_AGENTS)) {
        return '/to-rent' + path.split(LETTING_AGENTS).pop();
    }

    return '/for-sale' + path.split(FIND_AGENTS).pop();
};

export const lsrpToAfEcommerce = (
    lsrpEcommerce: EmailAllResultEcommerce,
    agents: Agent[]
): EmailAllResultEcommerce => {
    const mappedAgents: { [key: string]: Agent } = agents.reduce(
        (map, agent) => ({ ...map, [agent.id]: agent }),
        {}
    );
    const products =
        lsrpEcommerce?.purchase?.products?.map((product) => {
            if (!product) return {};

            const { id, price, brand, quantity } = product;
            return {
                id,
                price,
                brand,
                quantity,
                name: 'FA_Results',
                category: 'other',
                variant: mappedAgents[String(id)]?.featured
                    ? 'Featured'
                    : 'Standard'
            };
        }) || [];

    return {
        purchase: {
            ...lsrpEcommerce?.purchase,
            products
        }
    };
};

export const resultsToAgentsList = (
    results: Agent[]
): EmailAllResultBranches[] => {
    return results.map(
        ({ featured, displayName, logo, contactNumber, id }) => ({
            checked: true,
            featured,
            label: displayName,
            logo: logo?.uri,
            name: 'branch_id',
            type: 'checkbox',
            telephone: contactNumber,
            value: id
        })
    );
};
